import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { usePurchaseOrderByIdQuery, usePurchaseOrderStatusChangeMutation } from 'api';
import { PurchaseOrderStatusType } from 'models/PurchaseOrder';

export const useDetails = () => {
  const { id } = useParams() as { id: string };
  const { handleSuccess, handleError } = useNotificationMessages();
  const [assignmentModalState, setAssignmentModalState] = useState(false);
  const [shippingModalState, setShippingModalState] = useState(false);
  const [confirmOrderModalState, setConfirmOrderModalState] = useState(false);

  const { data = {}, refetch } = usePurchaseOrderByIdQuery({ id });
  const { purchaseOrder = {}, assignments = {} } = data;

  const [updatePurchaseOrderStatus] = usePurchaseOrderStatusChangeMutation();

  const handleStatusChange = useCallback(
    async (status: PurchaseOrderStatusType) => {
      if (status === 'ORDER_CONFIRMED') {
        setConfirmOrderModalState(true);
        return;
      }
      try {
        const payload = { id, status };
        const { data, error }: Record<string, any> = await updatePurchaseOrderStatus(payload);
        if (data?.success) {
          handleSuccess('Purchase Order status was successfully updated.');
          refetch();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [updatePurchaseOrderStatus, handleSuccess, handleError, id, refetch]
  );

  const onAssignmentOpen = useCallback(() => {
    setAssignmentModalState(true);
  }, []);

  const onAssignmentCancel = useCallback(() => {
    setAssignmentModalState(false);
  }, []);

  const onShippingOpen = useCallback(() => {
    setShippingModalState(true);
  }, []);

  const onShippingCancel = useCallback(() => {
    setShippingModalState(false);
  }, []);

  const onConfirmOrderCancel = useCallback(() => {
    setConfirmOrderModalState(false);
  }, []);

  return {
    purchaseOrder,
    assignments,
    handleStatusChange,
    assignmentModalState,
    onAssignmentCancel,
    onAssignmentOpen,
    shippingModalState,
    onShippingCancel,
    onShippingOpen,
    confirmOrderModalState,
    onConfirmOrderCancel,
  };
};
